import DasboardDinamicoIndex from './DashboardDinamicoIndex'
import DashboardDinamicoShow from './DashboardDinamicoShow'

export const dashboardDinamicoRoutes = [
  {
    name: 'dashboard-dinamico-index',
    path: '/dashboard-dinamico',
    component: DasboardDinamicoIndex
  },
  {
    name: 'dashboard-dinamico-show',
    path: '/dashboard-dinamico/:id',
    component: DashboardDinamicoShow
  }
]
